export default __webpack_public_path__ + "static/EYInterstateRegular-40de05b52cf1a97308804cfa6ca614df.woff";